module.exports = __webpack_public_path__ + "img/trip-placeholder.70bbaa4c.jpg";